/// <amd-module name="Wit/Settings/BoardsExternalIntegration/components/panels/DisableOAuth.props" />
export interface IDisableOAuthProps {
    disableOAuth: boolean;
}
